import React from 'react';

export default function Footer() {
  return (
    <footer className="border-t border-gray-200 py-12 px-6">
      <div className="max-w-6xl mx-auto flex justify-between items-center text-sm text-gray-500">
        <div>© 2026 Erika Hubbard. All rights reserved.</div>
        <div>Designed with care.</div>
      </div>
    </footer>
  );
}